<template>
    <div  class="form-sub-section notes-section" style="height:100%">
       <BulkCreate />
    </div>
</template>

<script>
    import axios from 'axios'
    import constants from '@/assets/js/constants'
    import * as utils from '@/assets/js/common.js'
    import BulkCreate from '@/components/custom/BulkCreate.vue'

    export default {
        name: 'BulkCreateView',
        components:{BulkCreate},
        props: {
           
        },
        data: () => (
            {
               
            }
        ),
        methods:
        {
           
        },
        mounted() 
        {
            
        }
    }
</script>